import React, { useEffect, useState } from "react";
import MobileFooter from "./MobileFooter";

const Footer = () => {
  const [showMobileFooter, setShowMobileFooter] = useState(false);
  useEffect(() => {
    const handleHamburgerEvent = (e) => {
      setShowMobileFooter(e.detail && e.detail.open);
    };
    window.addEventListener("hamburger-toggle", handleHamburgerEvent);
    return () =>
      window.removeEventListener("hamburger-toggle", handleHamburgerEvent);
  }, []);
  const isMobile = typeof window !== "undefined" && window.innerWidth < 1270;
  return (
    <>
      <footer className="footer-container">
        <div className="footer-content">
          {/* Logo Section */}
          <div className="footer-section logo-section">
            <img
              src="/shaagird-logo.svg"
              alt="Shaagird Logo"
              className="footer-logo"
              onClick={() => (window.location.href = "https://shaagird.org/")}
            />
          </div>

          {/* Links Section 1 - First Column */}
          <div className="footer-section links-section">
            <ul>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://about.shaagird.org/terms-conditions/")
                }
              >
                Terms and Conditions
              </li>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://about.shaagird.org/refund-policy/")
                }
              >
                Refund / Cancellation
              </li>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://about.shaagird.org/Policies/Data_Protection_Policy_Shaagird.pdf")
                }
              >
                Data Protection Policy
              </li>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://about.shaagird.org/Policies/Privacy_Policy_Shaagird.pdf")
                }
              >
                Privacy Policy
              </li>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://about.shaagird.org/Policies/DRD_Policy_Shaagird.pdf")
                }
              >
                DRD Policy
              </li>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://about.shaagird.org/Policies/Child_Protection_Policy_Shaagird.pdf")
                }
              >
                Child Protection Policy
              </li>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://about.shaagird.org/Policies/POSH_Policy_Shaagird.pdf")
                }
              >
                POSH Policy
              </li>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://about.shaagird.org/contact-us/")
                }
              >
                Contact
              </li>
            </ul>
          </div>

          {/* Links Section 2 - Second Column */}
          <div className="footer-section links-section2">
            <ul>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://about.shaagird.org/Policies/Whistleblower_Policy_Shaagird.pdf")
                }
              >
                Whistleblower Policy
              </li>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://about.shaagird.org/Policies/Conflict_of_Interest_Policy_Shaagird.pdf")
                }
              >
                Conflict of Interest
              </li>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://about.shaagird.org/Policies/Grievance_Redressal_Policy_Shaagird.pdf")
                }
              >
                Grievance Redressal Policy
              </li>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://about.shaagird.org/Policies/EDI_Policy_Shaagird.pdf")
                }
              >
                EDI Policy
              </li>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://about.shaagird.org/Policies/ABAC_Policy_Shaagird.pdf")
                }
              >
                ABAC Policy
              </li>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://about.shaagird.org/Policies/Financial_Management_Policy_Shaagird.pdf")
                }
              >
                Financial Management Policy
              </li>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://about.shaagird.org/Policies/Speaker_and_Event_Policy_Shaagird.pdf")
                }
              >
                Speaker & Event Policy
              </li>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://stories.shaagird.org/category/press/")
                }
              >
                Press
              </li>
            </ul>
          </div>

          {/* Efficiency Section - Third Column */}
          <div className="footer-section efficiency-section">
            <h3 className="section-title">Our Efficiency</h3>
            <div className="efficiency-chart">
              <div className="donut-chart"></div>
              <div className="efficiency-legend">
                <div className="legend-item">
                  <span className="legend-dot program"></span>
                  <span className="legend-text">75% Program </span>
                </div>
                <div className="legend-item">
                  <span className="legend-dot management"></span>
                  <span className="legend-text">17% Management</span>
                </div>
                <div className="legend-item">
                  <span className="legend-dot fundraising"></span>
                  <span className="legend-text">8% Fundraising</span>
                </div>
              </div>
            </div>
            <a
              href="https://donate.shaagird.org/"
              className="donate-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Donate ♡
            </a>
          </div>

          {/* Social Section - Fourth Column */}
          <div className="footer-section social-section">
            <div className="social-grid">
              <div className="social-item">
                <img
                  src="/img/instagram.png"
                  alt="Instagram"
                  className="social-icon"
                />
                <a
                  href="https://www.instagram.com/shaagirdfoundation/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>
              </div>
              <div className="social-item">
                <img
                  src="/img/twitter.png"
                  alt="Twitter"
                  className="social-icon"
                />
                <a
                  href="https://x.com/Shaagird__"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitter
                </a>
              </div>
              <div className="social-item">
                <img
                  src="/img/facebook.png"
                  alt="Facebook"
                  className="social-icon"
                />
                <a
                  href="https://www.facebook.com/people/Shaagird-Foundation/61556481338080/?mibextid=ZbWKwL"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </div>
              <div className="social-item">
                <img
                  src="/img/youtube.png"
                  alt="YouTube"
                  className="social-icon"
                />
                <a
                  href="https://www.youtube.com/@ShaagirdFoundation"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  YouTube
                </a>
              </div>
              <div className="social-item linkedin-item">
                <img
                  src="/img/linkedin.png"
                  alt="LinkedIn"
                  className="social-icon"
                />
                <a
                  href="https://www.linkedin.com/in/shaagird-foundation-9ba8182b7/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          .footer-container {
            width: 100%;
            background-color: white;
            padding: 30px 20px;
            font-family: "Poppins", sans-serif;
          }

          .footer-content {
            display: flex;
            justify-content: space-between;
            max-width: 1200px;
            margin: 0 auto;
          }

          .footer-section {
            flex: 1;
            padding: 0 15px;
          }

          .logo-section {
            flex: 0.5;
            display: flex;
            align-items: flex-start;
            justify-content: center;
          }

          .footer-logo {
            max-width: 100px;
            cursor: pointer;
          }

          .links-section ul,
          .links-section2 ul {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .links-section li,
          .links-section2 li {
            color: #333;
            font-size: 13px;
            margin-bottom: 8px;
            cursor: pointer;
            font-weight: 400;
          }

          .links-section li:hover,
          .links-section2 li:hover {
            color: #299d8e;
          }

          .section-title {
            font-size: 16px;
            font-weight: 600;
            margin-top: 0;
            margin-bottom: 20px;
            color: #333;
          }

          .efficiency-chart {
            display: flex;
            align-items: center;
            gap: 15px;
            margin-bottom: 20px;
          }

          .donut-chart {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            background: conic-gradient(
              #299d8e 0% 75%,
              #000 75% 92%,
              #ccc 92% 100%
            );
            position: relative;
            flex-shrink: 0;
          }

          .donut-chart::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 40px;
            height: 40px;
            background: white;
            border-radius: 50%;
          }

          .efficiency-legend {
            flex: 1;
          }

          .legend-item {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 6px;
          }

          .legend-dot {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
            flex-shrink: 0;
          }

          .legend-dot.program {
            background-color: #299d8e;
          }

          .legend-dot.management {
            background-color: #000;
          }

          .legend-dot.fundraising {
            background-color: #ccc;
          }

          .legend-text {
            font-size: 12px;
            color: #333;
            line-height: 1.2;
          }

          .donate-button {
            display: inline-block;
            background-color: #299d8e;
            color: #000;
            font-size: 14px;
            font-weight: 600;
            text-decoration: none;
            border-radius: 4px;
            padding: 8px 16px;
            margin-top: 10px;
            transition: all 0.3s ease;
          }

          .donate-button:hover {
            background-color: #264653;
            color: white;
          }

          .social-section {
            flex: 0.8;
          }

          .social-grid {
            display: flex;
            flex-direction: column;
          }

          .social-item {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 10px;
          }

          .social-icon {
            width: 20px;
            height: 20px;
          }

          .social-item a {
            font-size: 13px;
            color: #333;
            text-decoration: none;
            transition: color 0.3s ease;
          }

          .social-item a:hover {
            color: #299d8e;
          }

          /* Special class for LinkedIn item - mobile centering */
          .linkedin-item {
            /* Default styles - same as other social items */
          }

          /* Tablet Responsive - 768px to 991px */
          @media (min-width: 768px) and (max-width: 991px) {
            .footer-container {
              padding: 25px 15px;
              margin-bottom: 50px;
            }

            .footer-content {
              display: grid;
              grid-template-columns: 1fr 1fr;
              grid-template-rows: auto auto auto;
              gap: 25px 25px;
              max-width: 800px;
              justify-items: start;
              align-items: start;
            }

            .logo-section {
              grid-column: 1 / -1;
              justify-content: center;
              text-align: center;
              margin-bottom: 0;
              width: 100%;
            }

            .footer-logo {
              max-width: 120px;
            }

            .links-section,
            .links-section2 {
              padding: 0 15px;
              width: 100%;
            }

            .links-section li,
            .links-section2 li {
              font-size: 12px;
              margin-bottom: 0px;
              text-align: center;
            }

            .efficiency-section {
              display: flex;
              flex-direction: column;
              align-items: center;
              text-align: center;
              justify-self: center;
              width: 100%;
            }

            .section-title {
              font-size: 15px;
              margin-bottom: 15px;
              text-align: center;
            }

            .efficiency-chart {
              justify-content: center;
              align-items: center;
              margin-bottom: 15px;
              gap: 15px;
            }

            .donut-chart {
              width: 70px;
              height: 70px;
            }

            .donut-chart::after {
              width: 35px;
              height: 35px;
            }

            .efficiency-legend {
              text-align: left;
            }

            .legend-text {
              font-size: 11px;
            }

            .donate-button {
              font-size: 13px;
              padding: 10px 20px;
              align-self: center;
            }

            .social-section {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-self: center;
              width: 100%;
            }

            .social-grid {
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              gap: 15px 30px;
              width: 100%;
              max-width: 280px;
              justify-items: center;
              align-items: center;
            }

            .social-item {
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
              margin-bottom: 0;
              width: 100%;
            }

            .social-item a {
              font-size: 12px;
            }

            .social-icon {
              width: 18px;
              height: 18px;
            }
          }

          /* Below 768px - Mobile Responsive (2-column layout matching design) */
          @media (max-width: 767px) {
            .footer-container {
              padding: 25px 15px;
              margin-bottom: 0px;
            }

            .footer-content {
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 20px 16px;
            }

            .footer-section {
              width: 100%;
              flex: none;
              padding: 0;
            }

            .logo-section {
              grid-column: 1 / -1;
              display: flex;
              justify-content: flex-start;
              text-align: left;
              margin-bottom: 0;
            }

            .footer-logo {
              max-width: 110px;
              margin: 0;
            }

            .links-section,
            .links-section2 {
              margin-bottom: 0;
            }

            .links-section ul,
            .links-section2 ul {
              list-style: none;
              padding: 0;
              margin: 0;
            }

            .links-section li,
            .links-section2 li {
              font-size: 13px;
              font-weight: 500;
              color: #222;
              margin-bottom: 8px;
              text-align: left;
              line-height: 1.35;
            }

            .links-section li:hover,
            .links-section2 li:hover {
              color: #299d8e;
            }

            .efficiency-section {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              text-align: left;
              margin-bottom: 0;
            }

            .section-title {
              font-size: 16px;
              font-weight: 700;
              text-align: left;
              margin-top: 0;
              margin-bottom: 12px;
              color: #222;
            }

            .efficiency-chart {
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 10px;
              margin-bottom: 14px;
            }

            .donut-chart {
              width: 58px;
              height: 58px;
              flex-shrink: 0;
            }

            .donut-chart::after {
              width: 28px;
              height: 28px;
            }

            .efficiency-legend {
              text-align: left;
              display: flex;
              flex-direction: column;
              gap: 4px;
            }

            .legend-item {
              display: flex;
              align-items: center;
              gap: 6px;
            }

            .legend-text {
              font-size: 11px;
              font-weight: 500;
              color: #333;
              white-space: nowrap;
            }

            .donate-button {
              display: inline-block;
              background-color: #299d8e;
              color: #fff !important;
              text-align: center;
              margin: 0;
              font-size: 13px;
              font-weight: 600;
              padding: 8px 18px;
              border-radius: 6px;
              text-decoration: none;
            }

            .donate-button:hover {
              background-color: #264653;
            }

            .social-section {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;
              padding-top: 2px;
            }

            .social-grid {
              display: flex;
              flex-direction: column;
              gap: 10px;
              width: 100%;
              margin: 0;
            }

            .social-item {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              gap: 10px;
              margin-bottom: 0;
              width: 100%;
              text-align: left;
            }

            .social-item a {
              font-size: 13px;
              font-weight: 500;
              color: #222;
              text-decoration: none;
            }

            .social-item a:hover {
              color: #299d8e;
            }

            .social-icon {
              width: 18px;
              height: 18px;
              object-fit: contain;
            }

            .linkedin-item {
              grid-column: auto;
              justify-self: auto;
              width: 100%;
            }
          }

          /* Small Mobile - Below 480px */
          @media (max-width: 479px) {
            .footer-container {
              padding: 20px 12px;
              margin-bottom: 0px;
            }

            .footer-content {
              gap: 16px 12px;
            }

            .footer-logo {
              max-width: 95px;
            }

            .links-section li,
            .links-section2 li {
              font-size: 12px;
              margin-bottom: 7px;
            }

            .section-title {
              font-size: 15px;
              margin-bottom: 10px;
            }

            .donut-chart {
              width: 52px;
              height: 52px;
            }

            .donut-chart::after {
              width: 26px;
              height: 26px;
            }

            .legend-text {
              font-size: 10px;
            }

            .donate-button {
              font-size: 12px;
              padding: 7px 16px;
            }

            .social-grid {
              gap: 8px;
            }

            .social-icon {
              width: 16px;
              height: 16px;
            }

            .social-item a {
              font-size: 12px;
            }
          }

          .footer-top-bar {
            width: 100%;
            background: #299d8e;
            color: #fff;
            text-align: center;
            font-family: "Poppins", sans-serif;
            font-size: 12px;
            font-weight: 400;
            padding: 10px 0 8px 0;
            letter-spacing: 0.01em;
            border-top: 3px solid #e6e6a8;
          }
          @media (max-width: 1269px) {
            .footer-top-bar {
              font-size: 10px;
              padding: 9px 0 7px 0;
              margin-bottom: 75px;
            }
          }
          @media (max-width: 767px) {
            .footer-top-bar {
              font-size: 10px;
              padding: 8px 0 6px 0;
              margin-bottom: 75px;
            }
          }
          @media (max-width: 479px) {
            .footer-top-bar {
              font-size: 10px;
              padding: 7px 0 5px 0;
              margin-bottom: 75px;
            }
          }
        `}</style>
      </footer>
      <div className="footer-top-bar">
        © Shaagird is an educational program. It aims to provide education to
        the most marginalized children in our society through sponsorship,
        collaborating with various institutions.
      </div>
      {isMobile && showMobileFooter && <MobileFooter />}
    </>
  );
};

export default Footer;
